import _ from 'lodash';
import useModel from './useModel';

const typeToFilterKey = {
	'Advertiser': 'advertisers',
	'Team': 'teams',
	'GlobalDeal': 'globalDeals',
	'LineItem': 'lineItems'
};

const filterKeyToIdKey = {
	'advertisers': 'advertiserId',
	'teams': 'teamId',
	'globalDeals': 'globalDealId',
	'lineItems': 'lineItemId'
};

export default ({ defaultModel = {} }) => {
	const stateModel = useModel(defaultModel);
	const { get, set } = stateModel;

	const consumeObjects = objects => {
		const input = Array.isArray(objects) ? objects : [objects];
		// Collect all updates and then we'll "set" them into the model
		const updates = {};
		input.forEach(o => {
			const key = typeToFilterKey[o.__typename];
			if (key) {
				if (!updates[key]) updates[key] = [];
				updates[key].push({ id: o.id, name: o.name });
			}
		});
		Object.keys(updates).forEach(key => {
			// Replace all values for this filter key
			const values = _.uniqBy([...updates[key]], e => e.id);
			set(key, values);
		});
	};

	const getFilterIds = (filters, name) => {
		// Return the requested filter Ids
		const values = {};
		filters.filter(key => !name || key === name).forEach(key => {
			const v = get(key);
			if (v) {
				values[filterKeyToIdKey[key]] = Array.isArray(v) ? v.map(e => e.id)[0] : v.id;
			}
		});
		return values;
	};

	return { ...stateModel, consumeObjects, getFilterIds };
};
